/**
 * «Retirar y redirigir» escribe en blog_redirects y desactiva el artículo.
 * La web (legacy-redirect) sigue leyendo redirects.generated.json, no esa tabla.
 * Con el botón activo, retirar dejaría la URL en 404.
 * Se enciende solo cuando el paso (4) esté en producción: /api/legacy-redirect
 * lee blog_redirects.
 */
export const BLOG_RETIRE_AND_REDIRECT_ENABLED = false;

export const BLOG_RETIRE_DISABLED_MESSAGE =
    'Retirar y redirigir está apagado. La web publica las 301 desde el JSON de la landing, no desde blog_redirects. Retirar ahora desactivaría el artículo y la URL acabaría en 404.';
